/*
 * @Description: 
 * @Author: CcSimple
 * @Github: https://github.com/CcSimple
 * @Date: 2023-02-16 14:19:22
 * @LastEditors: CcSimple
 * @LastEditTime: 2023-02-16 14:23:13
 */
export default {
  name: "名称2",
};
